import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { environment } from '@environments/environment';
import { NgOptimizedImage } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-menu-services[closePopover]',
    templateUrl: './menu-services.component.html',
    styleUrls: ['./menu-services.component.scss'],
    imports: [NgOptimizedImage, TranslateModule],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuServicesComponent {
    closePopover = output<void>();

    readonly quickorderUrl = environment.quickorder;
    readonly geneticMonitoringUrl = environment.geneticMonitoring + '/home';
    readonly microbiomeUrl = environment.microbiome + '/home';
    readonly tagCenterUrl = 'https://tagcenter.info/';
    readonly tissueUrl = 'https://tissue.transnetyx.com/';

    close(): void {
        this.closePopover.emit();
    }
}
